import { Box } from '@mui/material'
import { Alert } from '@repo/ui'

import { REFERRALS_SWITCHED_OFF_DETAIL, REFERRALS_SWITCHED_OFF_LABEL } from 'constants/featureSwitches'
import { useReferralsEnabled } from 'hooks/api/useFeatures'

/**
 * VRG-680 — the label every INTERNAL referrals view carries while the Refer & earn launch
 * switch is off. Those views stay readable (they are staff-only), but a funnel that is not
 * moving must not read as a programme that is failing, so they say why.
 *
 * Renders nothing while on, and nothing until `/features` has answered (so a page does not
 * flash the notice on every load of a live programme). One component for the three views
 * (People → Referrals, Company → Referrals, Analytics → Affiliates) rather than three copies
 * of the sentence (§36).
 */
export const ReferralsSwitchedOffNotice = ({ mb = 4 }: { mb?: number }) => {
  const { enabled, isKnown } = useReferralsEnabled()
  if (!isKnown || enabled) return null
  return (
    <Box sx={{ mb }} data-testid="referrals-switched-off">
      <Alert severity="warning" title={REFERRALS_SWITCHED_OFF_LABEL} description={REFERRALS_SWITCHED_OFF_DETAIL} />
    </Box>
  )
}
